import React from "react";
import { BadgeCheck, Fingerprint, LayoutGrid, School2 } from "lucide-react";
import avatarPlaceholder from "../../assets/avatar.jpg";

function HighlightCard({ icon: Icon, label, value, accentClassName = "" }) {
  return (
    <div className={`student-highlight-card ${accentClassName}`.trim()}>
      <div className="student-highlight-icon">
        <Icon size={18} strokeWidth={2.2} />
      </div>
      <div>
        <p className="student-highlight-label">{label}</p>
        <p className="student-highlight-value">{value || "Not Available"}</p>
      </div>
    </div>
  );
}

export default function StudentCard({ summary }) {
  const {
    activeQr = false,
    className = "",
    name = "",
    photoUrl = "",
    section = "",
    studentId = "",
  } = summary;

  const subtitle = [className, section ? `Section ${section}` : ""]
    .filter(Boolean)
    .join(" • ");

  return (
    <section className="student-hero-card student-fade-in">
      <div className="student-hero-pattern" aria-hidden="true" />
      <div className="relative z-10 flex flex-col gap-8 lg:flex-row lg:items-center">
        <div className="student-photo-frame mx-auto lg:mx-0">
          <img
            src={photoUrl || avatarPlaceholder}
            alt={name || "Student"}
            className="h-full w-full object-cover"
            onError={(event) => {
              event.currentTarget.src = avatarPlaceholder;
            }}
          />
        </div>

        <div className="flex-1 text-center lg:text-left">
          <div className="flex flex-wrap items-center justify-center gap-3 lg:justify-start">
            <span className="student-eyebrow">Student Details</span>
            {activeQr && (
              <span className="student-qr-badge">
                <BadgeCheck size={16} strokeWidth={2.2} />
                Active QR
              </span>
            )}
          </div>

          <h1 className="mt-5 text-3xl font-semibold tracking-tight text-white sm:text-4xl">
            {name || "Student Profile"}
          </h1>
          <p className="mt-3 text-base text-slate-200 sm:text-lg">
            {subtitle || "Profile data fetched live from Firebase."}
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-3">
            <HighlightCard
              icon={Fingerprint}
              label="Student ID"
              value={studentId}
              accentClassName="student-highlight-card-primary"
            />
            <HighlightCard icon={School2} label="Class" value={className} />
            <HighlightCard icon={LayoutGrid} label="Section" value={section} />
          </div>
        </div>
      </div>
    </section>
  );
}
